import {
    Box,
    Dialog,
    Fab
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { useExecutionReportContext } from '../context'
import { useEffect } from 'react'

const PreviewDialog = ({ open, closePreviewModal }) => {
    const { materialesPreview } = useExecutionReportContext()
    useEffect(() => {
        console.log(materialesPreview)
    }, [materialesPreview])
    return (
        <Dialog
            open={open}
            onClose={closePreviewModal}
        >
            <div style={{ width: 600, padding: 10 }}>
                <div>
                    <h2>Resumen de Insumos y Materiales</h2>
                </div>
                {materialesPreview && <div style={{ height: 'calc(100vh - 290px)', overflowY: 'auto', borderColor: '#ccc', borderWidth: 1, borderStyle: 'solid', borderRadius: 20, padding: 10, marginTop: 50 }}>
                    {
                        (materialesPreview.length === 0)
                            ? <div>
                                <h3><strong>OT no registra uso de insumos y materiales para resumir</strong></h3>
                            </div>
                            : materialesPreview.map((element, i) => {
                                return (
                                    <div key={i} style={{ width: '100%' }}>
                                        <h2>
                                            {element.nombre}
                                        </h2>
                                        {
                                            element.materialespreview.map((item, index) => {
                                                return (
                                                    <div key={index} style={{ fontSize: 16, marginLeft: 20, borderBottomColor: '#ccc', borderBottomWidth: 1, borderBottomStyle: 'solid' }}>
                                                        <p>
                                                            <strong>{item.taskdesc}</strong>
                                                        </p>
                                                        <p>
                                                        Observación:
                                                            <br />
                                                            <strong>{item.obs01}</strong>
                                                        </p>
                                                        <p>
                                                        Unidad de medida: <strong>{item.unidad}</strong>
                                                        </p>
                                                        <p>
                                                        Cantidad proyectada: <strong>{item.cantidad}</strong>
                                                        </p>
                                                        <p>
                                                        Cantidad usada: <strong>{item.unidadData}</strong>
                                                        </p>
                                                        <p>
                                                        Diferencia: <strong>{item.diferencia}</strong>
                                                        </p>
                                                        {item.images && item.images.length > 0 && (
                                                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                                                {item.images.map((imgUrl, imgIndex) => (
                                                                    <img
                                                                        key={imgIndex}
                                                                        src={imgUrl}
                                                                        alt="Evidencia Insumo"
                                                                        style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 5, border: '1px solid #ccc' }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                    }
                </div>}
                <Fab onClick={closePreviewModal} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
            </div>
        </Dialog>
    )
}

export default PreviewDialog
